// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27%3E%3Cpath d=%27M1 1l5 5 5-5%27 stroke=%27%23a0aec0%27 stroke-width=%271.5%27 fill=%27none%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * FreelancerDetailPage — Professional Admin Panel Styles
 * All tab sections use classNames defined here for consistent, polished UI.
 */

/* ─── Page wrapper ─────────────────────────────────────────────────── */
.fdp-page-wrapper {
  background: #f7f8fc;
  padding: 20px 16px 40px;
}

html.chakra-ui-dark .fdp-page-wrapper,
body.chakra-ui-dark .fdp-page-wrapper {
  background: #0b1437;
}

/* ─── Back button ──────────────────────────────────────────────────── */
.fdp-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #4a5568;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 7px 14px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
  margin-bottom: 16px;
  text-decoration: none;
}

.fdp-back-btn:hover {
  background: #eef2ff;
  border-color: #667eea;
  color: #667eea;
}

html.chakra-ui-dark .fdp-back-btn,
body.chakra-ui-dark .fdp-back-btn {
  background: #1a2455;
  border-color: rgba(255,255,255,0.12);
  color: #718096;
}

html.chakra-ui-dark .fdp-back-btn:hover,
body.chakra-ui-dark .fdp-back-btn:hover {
  background: #2d3a7c;
  border-color: #667eea;
  color: #a5b4fc;
}

/* ─── Card wrapper ─────────────────────────────────────────────────── */
.fdp-card-wrap {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  overflow: hidden;
}

html.chakra-ui-dark .fdp-card-wrap,
body.chakra-ui-dark .fdp-card-wrap {
  background: #111c44;
  border-color: rgba(255,255,255,0.08);
}

/* ─── Tab bar ──────────────────────────────────────────────────────── */
.fdp-tab-bar {
  display: flex;
  align-items: stretch;
  gap: 0;
  border-bottom: 2px solid #e2e8f0;
  background: #fff;
  padding: 0 20px;
  overflow-x: auto;
  scrollbar-width: none;
}

.fdp-tab-bar::-webkit-scrollbar {
  display: none;
}

html.chakra-ui-dark .fdp-tab-bar,
body.chakra-ui-dark .fdp-tab-bar {
  background: #111c44;
  border-bottom-color: rgba(255,255,255,0.08);
}

.fdp-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 14px 18px 12px;
  font-size: 13.5px;
  font-weight: 600;
  color: #718096;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
  background: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
  -webkit-user-select: none;
          user-select: none;
}

.fdp-tab:hover {
  color: #4a5568;
}

.fdp-tab.active {
  color: #667eea;
  border-bottom-color: #667eea;
}

/* Chakra Tabs compatibility: treat selected Chakra <Tab> as active */
.fdp-tab[aria-selected="true"] {
  color: #667eea;
  border-bottom-color: #667eea;
}

html.chakra-ui-dark .fdp-tab,
body.chakra-ui-dark .fdp-tab {
  color: #718096;
}

html.chakra-ui-dark .fdp-tab.active,
body.chakra-ui-dark .fdp-tab.active {
  color: #a5b4fc;
  border-bottom-color: #a5b4fc;
}

.fdp-tab-icon {
  font-size: 15px;
  opacity: 0.75;
}

.fdp-tab.active .fdp-tab-icon {
  opacity: 1;
}

/* ─── Tab panel content ────────────────────────────────────────────── */
.fdp-tab-panel {
  padding: 24px 20px 28px;
}

/* ─── Section card ─────────────────────────────────────────────────── */
.fdp-section-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 20px;
}

html.chakra-ui-dark .fdp-section-card,
body.chakra-ui-dark .fdp-section-card {
  background: #111c44;
  border-color: rgba(255,255,255,0.08);
}

.fdp-section-card-accent {
  height: 3px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
}

.fdp-section-card-body {
  padding: 24px 28px;
}

/* ─── Profile header (Overview tab) ───────────────────────────────── */
.fdp-profile-header {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.fdp-avatar-wrap {
  position: relative;
  flex-shrink: 0;
}

.fdp-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e2e8f0;
  background: #eef2ff;
}

.fdp-profile-meta {
  flex: 1 1;
  min-width: 0;
}

.fdp-profile-name {
  font-size: 22px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.2;
  margin-bottom: 6px;
}

html.chakra-ui-dark .fdp-profile-name,
body.chakra-ui-dark .fdp-profile-name {
  color: #fff;
}

.fdp-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 3px 10px;
  border-radius: 20px;
}

/* ─── Section heading ──────────────────────────────────────────────── */
.fdp-section-heading {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #718096;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f5;
}

html.chakra-ui-dark .fdp-section-heading,
body.chakra-ui-dark .fdp-section-heading {
  color: #718096;
  border-bottom-color: rgba(255,255,255,0.06);
}

/* ─── Info grid ────────────────────────────────────────────────────── */
.fdp-info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px 28px;
}

@media (max-width: 900px) {
  .fdp-info-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 500px) {
  .fdp-info-grid {
    grid-template-columns: 1fr;
  }
}

.fdp-info-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

/* ─── Field label & value (global) ────────────────────────────────── */
.freelancer-detail-field-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  /* color: #718096; */
  color: #718096;
  line-height: 1.4;
}

html.chakra-ui-dark .freelancer-detail-field-label,
body.chakra-ui-dark .freelancer-detail-field-label {
  color: #718096;
}

th.freelancer-detail-field-label {
  text-transform: uppercase;
  letter-spacing: 0.07em;
}

.freelancer-detail-field-value {
  font-size: 14px;
  font-weight: 500;
  color: #2d3748;
  line-height: 1.55;
  word-break: break-word;
}

html.chakra-ui-dark .freelancer-detail-field-value,
body.chakra-ui-dark .freelancer-detail-field-value {
  color: #e2e8f0;
}

/* ─── Chip / pill tags ─────────────────────────────────────────────── */
.freelancer-detail-outline-chip {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  border: 1.5px solid #cbd5e0;
  background-color: #f7f8fc;
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1.4;
  color: #4a5568;
  transition: background 0.12s, border-color 0.12s;
}

.freelancer-detail-outline-chip:hover {
  background: #eef2ff;
  border-color: #667eea;
  color: #667eea;
}

html.chakra-ui-dark .freelancer-detail-outline-chip,
body.chakra-ui-dark .freelancer-detail-outline-chip {
  border-color: rgba(255,255,255,0.2);
  background: rgba(255,255,255,0.04);
  color: rgba(255,255,255,0.85);
}

/* ─── Chips row ────────────────────────────────────────────────────── */
.fdp-chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}

/* ─── Project card ─────────────────────────────────────────────────── */
.fdp-project-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  transition: box-shadow 0.15s;
}

.fdp-project-card:hover {
  box-shadow: 0 4px 16px rgba(102,126,234,0.10);
}

html.chakra-ui-dark .fdp-project-card,
body.chakra-ui-dark .fdp-project-card {
  background: #111c44;
  border-color: rgba(255,255,255,0.08);
}

.fdp-project-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 12px;
  border-bottom: 1px solid #f0f0f5;
  gap: 12px;
  flex-wrap: wrap;
}

html.chakra-ui-dark .fdp-project-card-header,
body.chakra-ui-dark .fdp-project-card-header {
  border-bottom-color: rgba(255,255,255,0.06);
}

.fdp-project-name {
  font-size: 15px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.3;
}

html.chakra-ui-dark .fdp-project-name,
body.chakra-ui-dark .fdp-project-name {
  color: #fff;
}

.fdp-project-type-badge {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  padding: 3px 10px;
  border-radius: 6px;
  background: #eef2ff;
  color: #667eea;
  white-space: nowrap;
}

html.chakra-ui-dark .fdp-project-type-badge,
body.chakra-ui-dark .fdp-project-type-badge {
  background: rgba(102,126,234,0.15);
  color: #a5b4fc;
}

.fdp-project-card-body {
  padding: 16px 20px 20px;
}

.fdp-project-meta-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px 20px;
  margin-bottom: 16px;
}

@media (max-width: 600px) {
  .fdp-project-meta-grid {
    grid-template-columns: 1fr;
  }
}

.fdp-project-description {
  font-size: 13.5px;
  color: #4a5568;
  line-height: 1.65;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f5;
}

html.chakra-ui-dark .fdp-project-description,
body.chakra-ui-dark .fdp-project-description {
  color: #718096;
  border-top-color: rgba(255,255,255,0.06);
}

/* ─── Section count badge ──────────────────────────────────────────── */
.fdp-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: 11px;
  background: #eef2ff;
  color: #667eea;
  font-size: 11px;
  font-weight: 700;
  margin-left: 8px;
}

html.chakra-ui-dark .fdp-count-badge,
body.chakra-ui-dark .fdp-count-badge {
  background: rgba(102,126,234,0.18);
  color: #a5b4fc;
}

/* ─── Section title row ────────────────────────────────────────────── */
.fdp-section-title-row {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}

.fdp-section-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.3;
}

html.chakra-ui-dark .fdp-section-title,
body.chakra-ui-dark .fdp-section-title {
  color: #fff;
}

/* ─── Certifications table ─────────────────────────────────────────── */
.fdp-cert-table-wrap {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

html.chakra-ui-dark .fdp-cert-table-wrap,
body.chakra-ui-dark .fdp-cert-table-wrap {
  border-color: rgba(255,255,255,0.08);
}

.fdp-cert-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
}

.fdp-cert-table thead tr {
  background: #f7f8fc;
}

html.chakra-ui-dark .fdp-cert-table thead tr,
body.chakra-ui-dark .fdp-cert-table thead tr {
  background: rgba(255,255,255,0.04);
}

.fdp-cert-table th {
  padding: 11px 16px;
  text-align: left;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #718096;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}

html.chakra-ui-dark .fdp-cert-table th,
body.chakra-ui-dark .fdp-cert-table th {
  color: #718096;
  border-bottom-color: rgba(255,255,255,0.08);
}

.fdp-cert-table td {
  padding: 12px 16px;
  color: #2d3748;
  border-bottom: 1px solid #f0f0f5;
  vertical-align: middle;
  font-size: 13.5px;
  font-weight: 500;
}

html.chakra-ui-dark .fdp-cert-table td,
body.chakra-ui-dark .fdp-cert-table td {
  color: #e2e8f0;
  border-bottom-color: rgba(255,255,255,0.05);
}

.fdp-cert-table tbody tr:last-child td {
  border-bottom: none;
}

.fdp-cert-table tbody tr:hover td {
  background: #f7f8fc;
}

html.chakra-ui-dark .fdp-cert-table tbody tr:hover td,
body.chakra-ui-dark .fdp-cert-table tbody tr:hover td {
  background: rgba(255,255,255,0.03);
}

/* ─── Education card ───────────────────────────────────────────────── */
.fdp-edu-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

html.chakra-ui-dark .fdp-edu-card,
body.chakra-ui-dark .fdp-edu-card {
  background: #111c44;
  border-color: rgba(255,255,255,0.08);
}

.fdp-edu-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #eef2ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #667eea;
  font-size: 18px;
}

html.chakra-ui-dark .fdp-edu-icon,
body.chakra-ui-dark .fdp-edu-icon {
  background: rgba(102,126,234,0.15);
  color: #a5b4fc;
}

.fdp-edu-content {
  flex: 1 1;
  min-width: 0;
}

.fdp-edu-degree {
  font-size: 14px;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 2px;
}

html.chakra-ui-dark .fdp-edu-degree,
body.chakra-ui-dark .fdp-edu-degree {
  color: #fff;
}

.fdp-edu-university {
  font-size: 14px;
  color: #4a5568;
  margin-bottom: 4px;
}

html.chakra-ui-dark .fdp-edu-university,
body.chakra-ui-dark .fdp-edu-university {
  color: #718096;
}

.fdp-edu-meta {
  font-size: 12px;
  color: #718096;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.year{
  font-size: 14px;
  color: #718096;
}

.fdp-edu-type-badge {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 5px;
  background: #f0fff4;
  color: #38a169;
}

html.chakra-ui-dark .fdp-edu-type-badge,
body.chakra-ui-dark .fdp-edu-type-badge {
  background: rgba(56,161,105,0.12);
  color: #68d391;
}

/* ─── Platform link row ────────────────────────────────────────────── */
.fdp-platform-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f5;
}

.fdp-platform-row:last-child {
  border-bottom: none;
}

html.chakra-ui-dark .fdp-platform-row,
body.chakra-ui-dark .fdp-platform-row {
  border-bottom-color: rgba(255,255,255,0.06);
}

.fdp-platform-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #667eea;
  flex-shrink: 0;
}

.fdp-platform-name {
  font-size: 13px;
  font-weight: 700;
  color: #4a5568;
  min-width: 120px;
}

html.chakra-ui-dark .fdp-platform-name,
body.chakra-ui-dark .fdp-platform-name {
  color: #718096;
}

.fdp-platform-link {
  font-size: 13px;
  color: #667eea;
  word-break: break-all;
  text-decoration: none;
}

.fdp-platform-link:hover {
  text-decoration: underline;
}

/* ─── Empty state ──────────────────────────────────────────────────── */
.fdp-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  color: #718096;
  font-size: 14px;
  gap: 8px;
}

/* ─── Loading state ────────────────────────────────────────────────── */
.fdp-loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  gap: 12px;
}

/* ─── Divider ──────────────────────────────────────────────────────── */
.fdp-divider {
  border: none;
  border-top: 1px solid #e2e8f0;
  margin: 20px 0;
}

html.chakra-ui-dark .fdp-divider,
body.chakra-ui-dark .fdp-divider {
  border-top-color: rgba(255,255,255,0.07);
}

/* ═══════════════════════════════════════════════════════════════════
   EDIT MODE — Professional Admin Panel Form Styles
   ═══════════════════════════════════════════════════════════════════ */

/* ─── Edit page wrapper ────────────────────────────────────────────── */
.fdp-edit-wrap {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ─── Edit section card ────────────────────────────────────────────── */
.fdp-edit-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
}

html.chakra-ui-dark .fdp-edit-card,
body.chakra-ui-dark .fdp-edit-card {
  background: #111c44;
  border-color: rgba(255,255,255,0.08);
}

.fdp-edit-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f5;
  background: #fafbff;
}

html.chakra-ui-dark .fdp-edit-card-header,
body.chakra-ui-dark .fdp-edit-card-header {
  background: rgba(255,255,255,0.03);
  border-bottom-color: rgba(255,255,255,0.06);
}

.fdp-edit-card-header-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #eef2ff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667eea;
  font-size: 16px;
  flex-shrink: 0;
}

html.chakra-ui-dark .fdp-edit-card-header-icon,
body.chakra-ui-dark .fdp-edit-card-header-icon {
  background: rgba(102,126,234,0.15);
  color: #a5b4fc;
}

.fdp-edit-card-title {
  font-size: 14px;
  font-weight: 700;
  color: #1a202c;
  line-height: 1.3;
}

html.chakra-ui-dark .fdp-edit-card-title,
body.chakra-ui-dark .fdp-edit-card-title {
  color: #fff;
}

.fdp-edit-card-body {
  padding: 24px;
}

/* ─── Profile edit header ──────────────────────────────────────────── */
.fdp-edit-profile-header {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #f0f0f5;
}

html.chakra-ui-dark .fdp-edit-profile-header,
body.chakra-ui-dark .fdp-edit-profile-header {
  border-bottom-color: rgba(255,255,255,0.06);
}

.fdp-edit-avatar-col {
  flex-shrink: 0;
}

.fdp-edit-name-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  flex: 1 1;
  min-width: 0;
}

@media (max-width: 480px) {
  .fdp-edit-name-row {
    grid-template-columns: 1fr;
  }
  .fdp-edit-profile-header {
    flex-direction: column;
  }
}

/* ─── Form grid ────────────────────────────────────────────────────── */
.fdp-form-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px 20px;
}

.fdp-form-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px 20px;
}

.fdp-form-grid-1 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

@media (max-width: 900px) {
  .fdp-form-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .fdp-form-grid,
  .fdp-form-grid-2 {
    grid-template-columns: 1fr;
  }
}

.fdp-form-col-full {
  grid-column: 1 / -1;
}

/* ─── Form field ───────────────────────────────────────────────────── */
.fdp-form-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.fdp-form-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #718096;
  display: flex;
  align-items: center;
  gap: 5px;
}

html.chakra-ui-dark .fdp-form-label,
body.chakra-ui-dark .fdp-form-label {
  color: #718096;
}

.fdp-form-label-required {
  color: #e53e3e;
  font-size: 12px;
  font-weight: 700;
}

.fdp-form-hint {
  font-size: 11px;
  color: #a0aec0;
  font-weight: 400;
  text-transform: none;
  letter-spacing: 0;
  margin-left: 4px;
}

/* ─── Input / Select / Textarea base ──────────────────────────────── */
.fdp-input,
.fdp-select,
.fdp-textarea {
  width: 100%;
  font-size: 13.5px;
  font-weight: 500;
  color: #2d3748;
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  padding: 9px 12px;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  box-sizing: border-box;
  font-family: inherit;
  line-height: 1.5;
}

html.chakra-ui-dark .fdp-input,
html.chakra-ui-dark .fdp-select,
html.chakra-ui-dark .fdp-textarea,
body.chakra-ui-dark .fdp-input,
body.chakra-ui-dark .fdp-select,
body.chakra-ui-dark .fdp-textarea {
  background: #1a2455;
  border-color: rgba(255,255,255,0.12);
  color: #e2e8f0;
}

.fdp-input:focus,
.fdp-select:focus,
.fdp-textarea:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102,126,234,0.15);
}

.fdp-input:hover:not(:focus),
.fdp-select:hover:not(:focus),
.fdp-textarea:hover:not(:focus) {
  border-color: #b794f4;
}

.fdp-input:disabled,
.fdp-select:disabled,
.fdp-textarea:disabled {
  background: #f7f8fc;
  color: #a0aec0;
  cursor: not-allowed;
}

html.chakra-ui-dark .fdp-input:disabled,
html.chakra-ui-dark .fdp-select:disabled,
html.chakra-ui-dark .fdp-textarea:disabled,
body.chakra-ui-dark .fdp-input:disabled,
body.chakra-ui-dark .fdp-select:disabled,
body.chakra-ui-dark .fdp-textarea:disabled {
  background: rgba(255,255,255,0.04);
}

.fdp-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
  cursor: pointer;
}

.fdp-textarea {
  resize: vertical;
  min-height: 96px;
}

/* ─── Char counter ─────────────────────────────────────────────────── */
.fdp-char-counter {
  font-size: 11px;
  color: #a0aec0;
  text-align: right;
  margin-top: 3px;
}

.fdp-char-counter.over {
  color: #e53e3e;
}

/* ─── Checkbox group ───────────────────────────────────────────────── */
.fdp-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: #fafbff;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  max-height: 220px;
  overflow-y: auto;
}

html.chakra-ui-dark .fdp-checkbox-group,
body.chakra-ui-dark .fdp-checkbox-group {
  background: rgba(255,255,255,0.03);
  border-color: rgba(255,255,255,0.1);
}

.fdp-checkbox-group-search {
  padding: 8px 10px;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 1;
}

html.chakra-ui-dark .fdp-checkbox-group-search,
body.chakra-ui-dark .fdp-checkbox-group-search {
  background: #1a2455;
  border-bottom-color: rgba(255,255,255,0.08);
}

.fdp-checkbox-group-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px;
  max-height: 180px;
  overflow-y: auto;
}

.fdp-checkbox-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #2d3748;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 6px;
  transition: background 0.1s;
  -webkit-user-select: none;
          user-select: none;
}

.fdp-checkbox-item:hover {
  background: #eef2ff;
}

html.chakra-ui-dark .fdp-checkbox-item,
body.chakra-ui-dark .fdp-checkbox-item {
  color: #e2e8f0;
}

html.chakra-ui-dark .fdp-checkbox-item:hover,
body.chakra-ui-dark .fdp-checkbox-item:hover {
  background: rgba(102,126,234,0.12);
}

.fdp-checkbox-item input[type="checkbox"] {
  width: 15px;
  height: 15px;
  accent-color: #667eea;
  cursor: pointer;
  flex-shrink: 0;
}

.fdp-checkbox-inline-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
  padding: 12px;
  background: #fafbff;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
}

html.chakra-ui-dark .fdp-checkbox-inline-row,
body.chakra-ui-dark .fdp-checkbox-inline-row {
  background: rgba(255,255,255,0.03);
  border-color: rgba(255,255,255,0.1);
}

/* ─── Project edit card ────────────────────────────────────────────── */
.fdp-project-edit-card {
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  transition: border-color 0.15s;
}

.fdp-project-edit-card:focus-within {
  border-color: #667eea;
}

html.chakra-ui-dark .fdp-project-edit-card,
body.chakra-ui-dark .fdp-project-edit-card {
  background: #111c44;
  border-color: rgba(255,255,255,0.1);
}

.fdp-project-edit-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #f7f8fc;
  border-bottom: 1px solid #e2e8f0;
}

html.chakra-ui-dark .fdp-project-edit-card-header,
body.chakra-ui-dark .fdp-project-edit-card-header {
  background: rgba(255,255,255,0.03);
  border-bottom-color: rgba(255,255,255,0.06);
}

.fdp-project-edit-card-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #667eea;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.fdp-project-edit-card-label {
  font-size: 13px;
  font-weight: 700;
  color: #1a202c;
  margin-left: 10px;
}

html.chakra-ui-dark .fdp-project-edit-card-label,
body.chakra-ui-dark .fdp-project-edit-card-label {
  color: #fff;
}

.fdp-project-edit-card-body {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ─── Save / action bar ────────────────────────────────────────────── */
.fdp-edit-action-bar {
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
}

.fdp-save-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 10px 24px;
  font-size: 13.5px;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.1s;
  outline: none;
}

.fdp-save-btn:hover {
  opacity: 0.92;
  transform: translateY(-1px);
}

.fdp-save-btn:active {
  transform: translateY(0);
}

.fdp-save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* ─── Empty / loading states in edit ──────────────────────────────── */
.fdp-edit-empty {
  text-align: center;
  padding: 32px;
  color: #a0aec0;
  font-size: 13.5px;
}

/* ═══════════════════════════════════════════════════════════════════
   CUSTOM SELECT (FdpSelect) — replaces native <select> dropdown
   ═══════════════════════════════════════════════════════════════════ */

.fdp-csel-wrap {
  position: relative;
  width: 100%;
}

.fdp-csel-wrap--disabled {
  opacity: 0.55;
  pointer-events: none;
}

/* ─── Trigger button ───────────────────────────────────────────────── */
.fdp-csel-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 9px 12px;
  font-size: 13.5px;
  font-weight: 500;
  color: #2d3748;
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  font-family: inherit;
  line-height: 1.5;
  box-sizing: border-box;
}

.fdp-csel-trigger:hover {
  border-color: #b794f4;
}

.fdp-csel-trigger:focus,
.fdp-csel-trigger[aria-expanded="true"] {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102,126,234,0.15);
}

html.chakra-ui-dark .fdp-csel-trigger,
body.chakra-ui-dark .fdp-csel-trigger {
  background: #1a2455;
  border-color: rgba(255,255,255,0.12);
  color: #e2e8f0;
}

html.chakra-ui-dark .fdp-csel-trigger:hover,
body.chakra-ui-dark .fdp-csel-trigger:hover {
  border-color: #7c6fcd;
}

html.chakra-ui-dark .fdp-csel-trigger:focus,
html.chakra-ui-dark .fdp-csel-trigger[aria-expanded="true"],
body.chakra-ui-dark .fdp-csel-trigger:focus,
body.chakra-ui-dark .fdp-csel-trigger[aria-expanded="true"] {
  border-color: #a5b4fc;
  box-shadow: 0 0 0 3px rgba(165,180,252,0.15);
}

.fdp-csel-value {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fdp-csel-placeholder {
  color: #a0aec0;
}

html.chakra-ui-dark .fdp-csel-placeholder,
body.chakra-ui-dark .fdp-csel-placeholder {
  color: #4a5568;
}

.fdp-csel-arrow {
  flex-shrink: 0;
  color: #a0aec0;
  transition: transform 0.18s;
}

.fdp-csel-arrow--open {
  transform: rotate(180deg);
}

/* ─── Dropdown panel ───────────────────────────────────────────────── */
.fdp-csel-dropdown {
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.10), 0 2px 6px rgba(0,0,0,0.06);
  overflow: hidden;
  animation: fdp-csel-in 0.12s ease;
}

@keyframes fdp-csel-in {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
}

html.chakra-ui-dark .fdp-csel-dropdown,
body.chakra-ui-dark .fdp-csel-dropdown {
  background: #1e2d6b;
  border-color: rgba(255,255,255,0.12);
  box-shadow: 0 8px 24px rgba(0,0,0,0.35);
}

/* ─── Search box ───────────────────────────────────────────────────── */
.fdp-csel-search-wrap {
  padding: 8px 10px;
  border-bottom: 1px solid #f0f0f5;
  background: #fafbff;
  position: sticky;
  top: 0;
  z-index: 1;
}

html.chakra-ui-dark .fdp-csel-search-wrap,
body.chakra-ui-dark .fdp-csel-search-wrap {
  background: #1a2455;
  border-bottom-color: rgba(255,255,255,0.08);
}

.fdp-csel-search {
  width: 100%;
  padding: 6px 10px;
  font-size: 12.5px;
  font-weight: 500;
  color: #2d3748;
  background: #fff;
  border: 1.5px solid #e2e8f0;
  border-radius: 6px;
  outline: none;
  font-family: inherit;
  box-sizing: border-box;
  transition: border-color 0.15s;
}

.fdp-csel-search:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102,126,234,0.12);
}

html.chakra-ui-dark .fdp-csel-search,
body.chakra-ui-dark .fdp-csel-search {
  background: #111c44;
  border-color: rgba(255,255,255,0.12);
  color: #e2e8f0;
}

/* ─── Options list ─────────────────────────────────────────────────── */
.fdp-csel-list {
  max-height: 220px;
  overflow-y: auto;
  padding: 4px;
  scrollbar-width: thin;
  scrollbar-color: #e2e8f0 transparent;
}

.fdp-csel-list::-webkit-scrollbar {
  width: 5px;
}

.fdp-csel-list::-webkit-scrollbar-track {
  background: transparent;
}

.fdp-csel-list::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 4px;
}

html.chakra-ui-dark .fdp-csel-list::-webkit-scrollbar-thumb,
body.chakra-ui-dark .fdp-csel-list::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.12);
}

/* ─── Option item ──────────────────────────────────────────────────── */
.fdp-csel-opt {
  padding: 8px 12px;
  font-size: 13.5px;
  font-weight: 500;
  color: #2d3748;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.1s, color 0.1s;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fdp-csel-opt:hover {
  background: #eef2ff;
  color: #667eea;
}

.fdp-csel-opt--active {
  background: #eef2ff;
  color: #667eea;
  font-weight: 600;
}

html.chakra-ui-dark .fdp-csel-opt,
body.chakra-ui-dark .fdp-csel-opt {
  color: #e2e8f0;
}

html.chakra-ui-dark .fdp-csel-opt:hover,
body.chakra-ui-dark .fdp-csel-opt:hover {
  background: rgba(102,126,234,0.15);
  color: #a5b4fc;
}

html.chakra-ui-dark .fdp-csel-opt--active,
body.chakra-ui-dark .fdp-csel-opt--active {
  background: rgba(102,126,234,0.2);
  color: #a5b4fc;
}

/* ─── Empty state ──────────────────────────────────────────────────── */
.fdp-csel-empty {
  padding: 12px;
  font-size: 12.5px;
  color: #a0aec0;
  text-align: center;
}

/* ═══════════════════════════════════════════════════════════════════
   MULTI-SELECT (FdpMultiSelect)
   ═══════════════════════════════════════════════════════════════════ */

/* ─── Multi-select trigger (chips inside) ──────────────────────────── */
.fdp-msel-trigger {
  height: auto !important;
  min-height: 40px;
  align-items: flex-start !important;
  padding: 6px 12px !important;
  cursor: pointer;
}

.fdp-msel-trigger-inner {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
}

.fdp-msel-chips-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 2px 0;
}

/* ─── Selected chips row (legacy — kept for compat) ────────────────── */
.fdp-msel-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 6px;
}

.fdp-msel-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px 3px 10px;
  background: #eef2ff;
  color: #667eea;
  border: 1px solid #c7d2fe;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
}

html.chakra-ui-dark .fdp-msel-chip,
body.chakra-ui-dark .fdp-msel-chip {
  background: rgba(102,126,234,0.18);
  color: #a5b4fc;
  border-color: rgba(102,126,234,0.3);
}

.fdp-msel-chip-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: none;
  background: none;
  color: #667eea;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  border-radius: 50%;
  padding: 0;
  transition: background 0.1s;
}

.fdp-msel-chip-remove:hover {
  background: #c7d2fe;
}

html.chakra-ui-dark .fdp-msel-chip-remove,
body.chakra-ui-dark .fdp-msel-chip-remove {
  color: #a5b4fc;
}

html.chakra-ui-dark .fdp-msel-chip-remove:hover,
body.chakra-ui-dark .fdp-msel-chip-remove:hover {
  background: rgba(102,126,234,0.3);
}

/* ─── Option row ───────────────────────────────────────────────────── */
.fdp-msel-opt {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.1s;
  -webkit-user-select: none;
          user-select: none;
}

.fdp-msel-opt:hover {
  background: #f5f7ff;
}

.fdp-msel-opt--checked {
  background: #eef2ff;
}

html.chakra-ui-dark .fdp-msel-opt:hover,
body.chakra-ui-dark .fdp-msel-opt:hover {
  background: rgba(102,126,234,0.1);
}

html.chakra-ui-dark .fdp-msel-opt--checked,
body.chakra-ui-dark .fdp-msel-opt--checked {
  background: rgba(102,126,234,0.18);
}

/* ─── Custom checkbox box ──────────────────────────────────────────── */
.fdp-msel-checkbox {
  width: 16px;
  height: 16px;
  border: 1.5px solid #cbd5e0;
  border-radius: 4px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.12s, border-color 0.12s;
}

.fdp-msel-checkbox--checked {
  background: #667eea;
  border-color: #667eea;
}

html.chakra-ui-dark .fdp-msel-checkbox,
body.chakra-ui-dark .fdp-msel-checkbox {
  background: #1a2455;
  border-color: rgba(255,255,255,0.2);
}

html.chakra-ui-dark .fdp-msel-checkbox--checked,
body.chakra-ui-dark .fdp-msel-checkbox--checked {
  background: #667eea;
  border-color: #667eea;
}

.fdp-msel-opt-label {
  font-size: 13.5px;
  font-weight: 500;
  color: #2d3748;
  flex: 1 1;
}

html.chakra-ui-dark .fdp-msel-opt-label,
body.chakra-ui-dark .fdp-msel-opt-label {
  color: #e2e8f0;
}
`, "",{"version":3,"sources":["webpack://./src/views/admin/freelancers/freelancerDetailPage.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,yEAAyE;AACzE;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,oBAAoB;EACpB,MAAM;EACN,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,qEAAqE;AACrE;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA,yEAAyE;AACzE;EACE,uBAAuB;AACzB;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;EACd,2CAA2C;AAC7C;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,wEAAwE;AACxE;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,mCAAmC;EACnC,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;EACd,wCAAwC;AAC1C;;AAEA,yEAAyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,iCAAiC;EACjC,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,QAAQ;AACV;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA,yEAAyE;AACzE;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;;wEAEwE;;AAExE,yEAAyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;;;EAGE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,gDAAgD;EAChD,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;;;;;EAME,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;;EAGE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;;EAME,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,yDAAgP;EAChP,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;EAEE,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;;wEAEwE;;AAExE;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;EAIE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,mEAAmE;EACnE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA,yEAAyE;AACzE;EACE,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA,yEAAyE;AACzE;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;EAEE,iCAAiC;EACjC,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;wEAEwE;;AAExE,yEAAyE;AACzE;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;EAClC,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAO;AACT;;AAEA;;EAEE,cAAc;AAChB","sourcesContent":["/**\n * FreelancerDetailPage — Professional Admin Panel Styles\n * All tab sections use classNames defined here for consistent, polished UI.\n */\n\n/* ─── Page wrapper ─────────────────────────────────────────────────── */\n.fdp-page-wrapper {\n  background: #f7f8fc;\n  padding: 20px 16px 40px;\n}\n\nhtml.chakra-ui-dark .fdp-page-wrapper,\nbody.chakra-ui-dark .fdp-page-wrapper {\n  background: #0b1437;\n}\n\n/* ─── Back button ──────────────────────────────────────────────────── */\n.fdp-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #4a5568;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 7px 14px;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s, color 0.15s;\n  margin-bottom: 16px;\n  text-decoration: none;\n}\n\n.fdp-back-btn:hover {\n  background: #eef2ff;\n  border-color: #667eea;\n  color: #667eea;\n}\n\nhtml.chakra-ui-dark .fdp-back-btn,\nbody.chakra-ui-dark .fdp-back-btn {\n  background: #1a2455;\n  border-color: rgba(255,255,255,0.12);\n  color: #718096;\n}\n\nhtml.chakra-ui-dark .fdp-back-btn:hover,\nbody.chakra-ui-dark .fdp-back-btn:hover {\n  background: #2d3a7c;\n  border-color: #667eea;\n  color: #a5b4fc;\n}\n\n/* ─── Card wrapper ─────────────────────────────────────────────────── */\n.fdp-card-wrap {\n  background: #fff;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.06);\n  overflow: hidden;\n}\n\nhtml.chakra-ui-dark .fdp-card-wrap,\nbody.chakra-ui-dark .fdp-card-wrap {\n  background: #111c44;\n  border-color: rgba(255,255,255,0.08);\n}\n\n/* ─── Tab bar ──────────────────────────────────────────────────────── */\n.fdp-tab-bar {\n  display: flex;\n  align-items: stretch;\n  gap: 0;\n  border-bottom: 2px solid #e2e8f0;\n  background: #fff;\n  padding: 0 20px;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.fdp-tab-bar::-webkit-scrollbar {\n  display: none;\n}\n\nhtml.chakra-ui-dark .fdp-tab-bar,\nbody.chakra-ui-dark .fdp-tab-bar {\n  background: #111c44;\n  border-bottom-color: rgba(255,255,255,0.08);\n}\n\n.fdp-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 14px 18px 12px;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #718096;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: color 0.15s, border-color 0.15s;\n  background: transparent;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  outline: none;\n  user-select: none;\n}\n\n.fdp-tab:hover {\n  color: #4a5568;\n}\n\n.fdp-tab.active {\n  color: #667eea;\n  border-bottom-color: #667eea;\n}\n\n/* Chakra Tabs compatibility: treat selected Chakra <Tab> as active */\n.fdp-tab[aria-selected=\"true\"] {\n  color: #667eea;\n  border-bottom-color: #667eea;\n}\n\nhtml.chakra-ui-dark .fdp-tab,\nbody.chakra-ui-dark .fdp-tab {\n  color: #718096;\n}\n\nhtml.chakra-ui-dark .fdp-tab.active,\nbody.chakra-ui-dark .fdp-tab.active {\n  color: #a5b4fc;\n  border-bottom-color: #a5b4fc;\n}\n\n.fdp-tab-icon {\n  font-size: 15px;\n  opacity: 0.75;\n}\n\n.fdp-tab.active .fdp-tab-icon {\n  opacity: 1;\n}\n\n/* ─── Tab panel content ────────────────────────────────────────────── */\n.fdp-tab-panel {\n  padding: 24px 20px 28px;\n}\n\n/* ─── Section card ─────────────────────────────────────────────────── */\n.fdp-section-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\nhtml.chakra-ui-dark .fdp-section-card,\nbody.chakra-ui-dark .fdp-section-card {\n  background: #111c44;\n  border-color: rgba(255,255,255,0.08);\n}\n\n.fdp-section-card-accent {\n  height: 3px;\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n}\n\n.fdp-section-card-body {\n  padding: 24px 28px;\n}\n\n/* ─── Profile header (Overview tab) ───────────────────────────────── */\n.fdp-profile-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n\n.fdp-avatar-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.fdp-avatar {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid #e2e8f0;\n  background: #eef2ff;\n}\n\n.fdp-profile-meta {\n  flex: 1;\n  min-width: 0;\n}\n\n.fdp-profile-name {\n  font-size: 22px;\n  font-weight: 700;\n  color: #1a202c;\n  line-height: 1.2;\n  margin-bottom: 6px;\n}\n\nhtml.chakra-ui-dark .fdp-profile-name,\nbody.chakra-ui-dark .fdp-profile-name {\n  color: #fff;\n}\n\n.fdp-status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  padding: 3px 10px;\n  border-radius: 20px;\n}\n\n/* ─── Section heading ──────────────────────────────────────────────── */\n.fdp-section-heading {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #718096;\n  margin-bottom: 16px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #f0f0f5;\n}\n\nhtml.chakra-ui-dark .fdp-section-heading,\nbody.chakra-ui-dark .fdp-section-heading {\n  color: #718096;\n  border-bottom-color: rgba(255,255,255,0.06);\n}\n\n/* ─── Info grid ────────────────────────────────────────────────────── */\n.fdp-info-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px 28px;\n}\n\n@media (max-width: 900px) {\n  .fdp-info-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 500px) {\n  .fdp-info-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.fdp-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n/* ─── Field label & value (global) ────────────────────────────────── */\n.freelancer-detail-field-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  /* color: #718096; */\n  color: #718096;\n  line-height: 1.4;\n}\n\nhtml.chakra-ui-dark .freelancer-detail-field-label,\nbody.chakra-ui-dark .freelancer-detail-field-label {\n  color: #718096;\n}\n\nth.freelancer-detail-field-label {\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n}\n\n.freelancer-detail-field-value {\n  font-size: 14px;\n  font-weight: 500;\n  color: #2d3748;\n  line-height: 1.55;\n  word-break: break-word;\n}\n\nhtml.chakra-ui-dark .freelancer-detail-field-value,\nbody.chakra-ui-dark .freelancer-detail-field-value {\n  color: #e2e8f0;\n}\n\n/* ─── Chip / pill tags ─────────────────────────────────────────────── */\n.freelancer-detail-outline-chip {\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  border: 1.5px solid #cbd5e0;\n  background-color: #f7f8fc;\n  border-radius: 20px;\n  padding: 4px 12px;\n  font-size: 12.5px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: #4a5568;\n  transition: background 0.12s, border-color 0.12s;\n}\n\n.freelancer-detail-outline-chip:hover {\n  background: #eef2ff;\n  border-color: #667eea;\n  color: #667eea;\n}\n\nhtml.chakra-ui-dark .freelancer-detail-outline-chip,\nbody.chakra-ui-dark .freelancer-detail-outline-chip {\n  border-color: rgba(255,255,255,0.2);\n  background: rgba(255,255,255,0.04);\n  color: rgba(255,255,255,0.85);\n}\n\n/* ─── Chips row ────────────────────────────────────────────────────── */\n.fdp-chips-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n/* ─── Project card ─────────────────────────────────────────────────── */\n.fdp-project-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n  transition: box-shadow 0.15s;\n}\n\n.fdp-project-card:hover {\n  box-shadow: 0 4px 16px rgba(102,126,234,0.10);\n}\n\nhtml.chakra-ui-dark .fdp-project-card,\nbody.chakra-ui-dark .fdp-project-card {\n  background: #111c44;\n  border-color: rgba(255,255,255,0.08);\n}\n\n.fdp-project-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px 12px;\n  border-bottom: 1px solid #f0f0f5;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\nhtml.chakra-ui-dark .fdp-project-card-header,\nbody.chakra-ui-dark .fdp-project-card-header {\n  border-bottom-color: rgba(255,255,255,0.06);\n}\n\n.fdp-project-name {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a202c;\n  line-height: 1.3;\n}\n\nhtml.chakra-ui-dark .fdp-project-name,\nbody.chakra-ui-dark .fdp-project-name {\n  color: #fff;\n}\n\n.fdp-project-type-badge {\n  display: inline-flex;\n  align-items: center;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  padding: 3px 10px;\n  border-radius: 6px;\n  background: #eef2ff;\n  color: #667eea;\n  white-space: nowrap;\n}\n\nhtml.chakra-ui-dark .fdp-project-type-badge,\nbody.chakra-ui-dark .fdp-project-type-badge {\n  background: rgba(102,126,234,0.15);\n  color: #a5b4fc;\n}\n\n.fdp-project-card-body {\n  padding: 16px 20px 20px;\n}\n\n.fdp-project-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px 20px;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 600px) {\n  .fdp-project-meta-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.fdp-project-description {\n  font-size: 13.5px;\n  color: #4a5568;\n  line-height: 1.65;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #f0f0f5;\n}\n\nhtml.chakra-ui-dark .fdp-project-description,\nbody.chakra-ui-dark .fdp-project-description {\n  color: #718096;\n  border-top-color: rgba(255,255,255,0.06);\n}\n\n/* ─── Section count badge ──────────────────────────────────────────── */\n.fdp-count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 22px;\n  padding: 0 7px;\n  border-radius: 11px;\n  background: #eef2ff;\n  color: #667eea;\n  font-size: 11px;\n  font-weight: 700;\n  margin-left: 8px;\n}\n\nhtml.chakra-ui-dark .fdp-count-badge,\nbody.chakra-ui-dark .fdp-count-badge {\n  background: rgba(102,126,234,0.18);\n  color: #a5b4fc;\n}\n\n/* ─── Section title row ────────────────────────────────────────────── */\n.fdp-section-title-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 18px;\n}\n\n.fdp-section-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a202c;\n  line-height: 1.3;\n}\n\nhtml.chakra-ui-dark .fdp-section-title,\nbody.chakra-ui-dark .fdp-section-title {\n  color: #fff;\n}\n\n/* ─── Certifications table ─────────────────────────────────────────── */\n.fdp-cert-table-wrap {\n  overflow-x: auto;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\nhtml.chakra-ui-dark .fdp-cert-table-wrap,\nbody.chakra-ui-dark .fdp-cert-table-wrap {\n  border-color: rgba(255,255,255,0.08);\n}\n\n.fdp-cert-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13.5px;\n}\n\n.fdp-cert-table thead tr {\n  background: #f7f8fc;\n}\n\nhtml.chakra-ui-dark .fdp-cert-table thead tr,\nbody.chakra-ui-dark .fdp-cert-table thead tr {\n  background: rgba(255,255,255,0.04);\n}\n\n.fdp-cert-table th {\n  padding: 11px 16px;\n  text-align: left;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #718096;\n  border-bottom: 1px solid #e2e8f0;\n  white-space: nowrap;\n}\n\nhtml.chakra-ui-dark .fdp-cert-table th,\nbody.chakra-ui-dark .fdp-cert-table th {\n  color: #718096;\n  border-bottom-color: rgba(255,255,255,0.08);\n}\n\n.fdp-cert-table td {\n  padding: 12px 16px;\n  color: #2d3748;\n  border-bottom: 1px solid #f0f0f5;\n  vertical-align: middle;\n  font-size: 13.5px;\n  font-weight: 500;\n}\n\nhtml.chakra-ui-dark .fdp-cert-table td,\nbody.chakra-ui-dark .fdp-cert-table td {\n  color: #e2e8f0;\n  border-bottom-color: rgba(255,255,255,0.05);\n}\n\n.fdp-cert-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.fdp-cert-table tbody tr:hover td {\n  background: #f7f8fc;\n}\n\nhtml.chakra-ui-dark .fdp-cert-table tbody tr:hover td,\nbody.chakra-ui-dark .fdp-cert-table tbody tr:hover td {\n  background: rgba(255,255,255,0.03);\n}\n\n/* ─── Education card ───────────────────────────────────────────────── */\n.fdp-edu-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 20px 24px;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\nhtml.chakra-ui-dark .fdp-edu-card,\nbody.chakra-ui-dark .fdp-edu-card {\n  background: #111c44;\n  border-color: rgba(255,255,255,0.08);\n}\n\n.fdp-edu-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: #eef2ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #667eea;\n  font-size: 18px;\n}\n\nhtml.chakra-ui-dark .fdp-edu-icon,\nbody.chakra-ui-dark .fdp-edu-icon {\n  background: rgba(102,126,234,0.15);\n  color: #a5b4fc;\n}\n\n.fdp-edu-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.fdp-edu-degree {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a202c;\n  margin-bottom: 2px;\n}\n\nhtml.chakra-ui-dark .fdp-edu-degree,\nbody.chakra-ui-dark .fdp-edu-degree {\n  color: #fff;\n}\n\n.fdp-edu-university {\n  font-size: 14px;\n  color: #4a5568;\n  margin-bottom: 4px;\n}\n\nhtml.chakra-ui-dark .fdp-edu-university,\nbody.chakra-ui-dark .fdp-edu-university {\n  color: #718096;\n}\n\n.fdp-edu-meta {\n  font-size: 12px;\n  color: #718096;\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.year{\n  font-size: 14px;\n  color: #718096;\n}\n\n.fdp-edu-type-badge {\n  display: inline-flex;\n  align-items: center;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 5px;\n  background: #f0fff4;\n  color: #38a169;\n}\n\nhtml.chakra-ui-dark .fdp-edu-type-badge,\nbody.chakra-ui-dark .fdp-edu-type-badge {\n  background: rgba(56,161,105,0.12);\n  color: #68d391;\n}\n\n/* ─── Platform link row ────────────────────────────────────────────── */\n.fdp-platform-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 0;\n  border-bottom: 1px solid #f0f0f5;\n}\n\n.fdp-platform-row:last-child {\n  border-bottom: none;\n}\n\nhtml.chakra-ui-dark .fdp-platform-row,\nbody.chakra-ui-dark .fdp-platform-row {\n  border-bottom-color: rgba(255,255,255,0.06);\n}\n\n.fdp-platform-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #667eea;\n  flex-shrink: 0;\n}\n\n.fdp-platform-name {\n  font-size: 13px;\n  font-weight: 700;\n  color: #4a5568;\n  min-width: 120px;\n}\n\nhtml.chakra-ui-dark .fdp-platform-name,\nbody.chakra-ui-dark .fdp-platform-name {\n  color: #718096;\n}\n\n.fdp-platform-link {\n  font-size: 13px;\n  color: #667eea;\n  word-break: break-all;\n  text-decoration: none;\n}\n\n.fdp-platform-link:hover {\n  text-decoration: underline;\n}\n\n/* ─── Empty state ──────────────────────────────────────────────────── */\n.fdp-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  color: #718096;\n  font-size: 14px;\n  gap: 8px;\n}\n\n/* ─── Loading state ────────────────────────────────────────────────── */\n.fdp-loading-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 24px;\n  gap: 12px;\n}\n\n/* ─── Divider ──────────────────────────────────────────────────────── */\n.fdp-divider {\n  border: none;\n  border-top: 1px solid #e2e8f0;\n  margin: 20px 0;\n}\n\nhtml.chakra-ui-dark .fdp-divider,\nbody.chakra-ui-dark .fdp-divider {\n  border-top-color: rgba(255,255,255,0.07);\n}\n\n/* ═══════════════════════════════════════════════════════════════════\n   EDIT MODE — Professional Admin Panel Form Styles\n   ═══════════════════════════════════════════════════════════════════ */\n\n/* ─── Edit page wrapper ────────────────────────────────────────────── */\n.fdp-edit-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* ─── Edit section card ────────────────────────────────────────────── */\n.fdp-edit-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\nhtml.chakra-ui-dark .fdp-edit-card,\nbody.chakra-ui-dark .fdp-edit-card {\n  background: #111c44;\n  border-color: rgba(255,255,255,0.08);\n}\n\n.fdp-edit-card-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 16px 24px;\n  border-bottom: 1px solid #f0f0f5;\n  background: #fafbff;\n}\n\nhtml.chakra-ui-dark .fdp-edit-card-header,\nbody.chakra-ui-dark .fdp-edit-card-header {\n  background: rgba(255,255,255,0.03);\n  border-bottom-color: rgba(255,255,255,0.06);\n}\n\n.fdp-edit-card-header-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: #eef2ff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #667eea;\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\nhtml.chakra-ui-dark .fdp-edit-card-header-icon,\nbody.chakra-ui-dark .fdp-edit-card-header-icon {\n  background: rgba(102,126,234,0.15);\n  color: #a5b4fc;\n}\n\n.fdp-edit-card-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a202c;\n  line-height: 1.3;\n}\n\nhtml.chakra-ui-dark .fdp-edit-card-title,\nbody.chakra-ui-dark .fdp-edit-card-title {\n  color: #fff;\n}\n\n.fdp-edit-card-body {\n  padding: 24px;\n}\n\n/* ─── Profile edit header ──────────────────────────────────────────── */\n.fdp-edit-profile-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 20px;\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #f0f0f5;\n}\n\nhtml.chakra-ui-dark .fdp-edit-profile-header,\nbody.chakra-ui-dark .fdp-edit-profile-header {\n  border-bottom-color: rgba(255,255,255,0.06);\n}\n\n.fdp-edit-avatar-col {\n  flex-shrink: 0;\n}\n\n.fdp-edit-name-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  flex: 1;\n  min-width: 0;\n}\n\n@media (max-width: 480px) {\n  .fdp-edit-name-row {\n    grid-template-columns: 1fr;\n  }\n  .fdp-edit-profile-header {\n    flex-direction: column;\n  }\n}\n\n/* ─── Form grid ────────────────────────────────────────────────────── */\n.fdp-form-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px 20px;\n}\n\n.fdp-form-grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px 20px;\n}\n\n.fdp-form-grid-1 {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n}\n\n@media (max-width: 900px) {\n  .fdp-form-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 600px) {\n  .fdp-form-grid,\n  .fdp-form-grid-2 {\n    grid-template-columns: 1fr;\n  }\n}\n\n.fdp-form-col-full {\n  grid-column: 1 / -1;\n}\n\n/* ─── Form field ───────────────────────────────────────────────────── */\n.fdp-form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.fdp-form-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #718096;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\nhtml.chakra-ui-dark .fdp-form-label,\nbody.chakra-ui-dark .fdp-form-label {\n  color: #718096;\n}\n\n.fdp-form-label-required {\n  color: #e53e3e;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.fdp-form-hint {\n  font-size: 11px;\n  color: #a0aec0;\n  font-weight: 400;\n  text-transform: none;\n  letter-spacing: 0;\n  margin-left: 4px;\n}\n\n/* ─── Input / Select / Textarea base ──────────────────────────────── */\n.fdp-input,\n.fdp-select,\n.fdp-textarea {\n  width: 100%;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: #2d3748;\n  background: #fff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 9px 12px;\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n  box-sizing: border-box;\n  font-family: inherit;\n  line-height: 1.5;\n}\n\nhtml.chakra-ui-dark .fdp-input,\nhtml.chakra-ui-dark .fdp-select,\nhtml.chakra-ui-dark .fdp-textarea,\nbody.chakra-ui-dark .fdp-input,\nbody.chakra-ui-dark .fdp-select,\nbody.chakra-ui-dark .fdp-textarea {\n  background: #1a2455;\n  border-color: rgba(255,255,255,0.12);\n  color: #e2e8f0;\n}\n\n.fdp-input:focus,\n.fdp-select:focus,\n.fdp-textarea:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102,126,234,0.15);\n}\n\n.fdp-input:hover:not(:focus),\n.fdp-select:hover:not(:focus),\n.fdp-textarea:hover:not(:focus) {\n  border-color: #b794f4;\n}\n\n.fdp-input:disabled,\n.fdp-select:disabled,\n.fdp-textarea:disabled {\n  background: #f7f8fc;\n  color: #a0aec0;\n  cursor: not-allowed;\n}\n\nhtml.chakra-ui-dark .fdp-input:disabled,\nhtml.chakra-ui-dark .fdp-select:disabled,\nhtml.chakra-ui-dark .fdp-textarea:disabled,\nbody.chakra-ui-dark .fdp-input:disabled,\nbody.chakra-ui-dark .fdp-select:disabled,\nbody.chakra-ui-dark .fdp-textarea:disabled {\n  background: rgba(255,255,255,0.04);\n}\n\n.fdp-select {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23a0aec0' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  padding-right: 36px;\n  cursor: pointer;\n}\n\n.fdp-textarea {\n  resize: vertical;\n  min-height: 96px;\n}\n\n/* ─── Char counter ─────────────────────────────────────────────────── */\n.fdp-char-counter {\n  font-size: 11px;\n  color: #a0aec0;\n  text-align: right;\n  margin-top: 3px;\n}\n\n.fdp-char-counter.over {\n  color: #e53e3e;\n}\n\n/* ─── Checkbox group ───────────────────────────────────────────────── */\n.fdp-checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  background: #fafbff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  max-height: 220px;\n  overflow-y: auto;\n}\n\nhtml.chakra-ui-dark .fdp-checkbox-group,\nbody.chakra-ui-dark .fdp-checkbox-group {\n  background: rgba(255,255,255,0.03);\n  border-color: rgba(255,255,255,0.1);\n}\n\n.fdp-checkbox-group-search {\n  padding: 8px 10px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #fff;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\nhtml.chakra-ui-dark .fdp-checkbox-group-search,\nbody.chakra-ui-dark .fdp-checkbox-group-search {\n  background: #1a2455;\n  border-bottom-color: rgba(255,255,255,0.08);\n}\n\n.fdp-checkbox-group-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 10px;\n  max-height: 180px;\n  overflow-y: auto;\n}\n\n.fdp-checkbox-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #2d3748;\n  cursor: pointer;\n  padding: 4px 6px;\n  border-radius: 6px;\n  transition: background 0.1s;\n  user-select: none;\n}\n\n.fdp-checkbox-item:hover {\n  background: #eef2ff;\n}\n\nhtml.chakra-ui-dark .fdp-checkbox-item,\nbody.chakra-ui-dark .fdp-checkbox-item {\n  color: #e2e8f0;\n}\n\nhtml.chakra-ui-dark .fdp-checkbox-item:hover,\nbody.chakra-ui-dark .fdp-checkbox-item:hover {\n  background: rgba(102,126,234,0.12);\n}\n\n.fdp-checkbox-item input[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n  accent-color: #667eea;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.fdp-checkbox-inline-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 20px;\n  padding: 12px;\n  background: #fafbff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n}\n\nhtml.chakra-ui-dark .fdp-checkbox-inline-row,\nbody.chakra-ui-dark .fdp-checkbox-inline-row {\n  background: rgba(255,255,255,0.03);\n  border-color: rgba(255,255,255,0.1);\n}\n\n/* ─── Project edit card ────────────────────────────────────────────── */\n.fdp-project-edit-card {\n  background: #fff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 16px;\n  transition: border-color 0.15s;\n}\n\n.fdp-project-edit-card:focus-within {\n  border-color: #667eea;\n}\n\nhtml.chakra-ui-dark .fdp-project-edit-card,\nbody.chakra-ui-dark .fdp-project-edit-card {\n  background: #111c44;\n  border-color: rgba(255,255,255,0.1);\n}\n\n.fdp-project-edit-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  background: #f7f8fc;\n  border-bottom: 1px solid #e2e8f0;\n}\n\nhtml.chakra-ui-dark .fdp-project-edit-card-header,\nbody.chakra-ui-dark .fdp-project-edit-card-header {\n  background: rgba(255,255,255,0.03);\n  border-bottom-color: rgba(255,255,255,0.06);\n}\n\n.fdp-project-edit-card-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: #667eea;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.fdp-project-edit-card-label {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1a202c;\n  margin-left: 10px;\n}\n\nhtml.chakra-ui-dark .fdp-project-edit-card-label,\nbody.chakra-ui-dark .fdp-project-edit-card-label {\n  color: #fff;\n}\n\n.fdp-project-edit-card-body {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ─── Save / action bar ────────────────────────────────────────────── */\n.fdp-edit-action-bar {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 8px;\n}\n\n.fdp-save-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 10px 24px;\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #fff;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.15s, transform 0.1s;\n  outline: none;\n}\n\n.fdp-save-btn:hover {\n  opacity: 0.92;\n  transform: translateY(-1px);\n}\n\n.fdp-save-btn:active {\n  transform: translateY(0);\n}\n\n.fdp-save-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* ─── Empty / loading states in edit ──────────────────────────────── */\n.fdp-edit-empty {\n  text-align: center;\n  padding: 32px;\n  color: #a0aec0;\n  font-size: 13.5px;\n}\n\n/* ═══════════════════════════════════════════════════════════════════\n   CUSTOM SELECT (FdpSelect) — replaces native <select> dropdown\n   ═══════════════════════════════════════════════════════════════════ */\n\n.fdp-csel-wrap {\n  position: relative;\n  width: 100%;\n}\n\n.fdp-csel-wrap--disabled {\n  opacity: 0.55;\n  pointer-events: none;\n}\n\n/* ─── Trigger button ───────────────────────────────────────────────── */\n.fdp-csel-trigger {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 9px 12px;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: #2d3748;\n  background: #fff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  text-align: left;\n  outline: none;\n  transition: border-color 0.15s, box-shadow 0.15s;\n  font-family: inherit;\n  line-height: 1.5;\n  box-sizing: border-box;\n}\n\n.fdp-csel-trigger:hover {\n  border-color: #b794f4;\n}\n\n.fdp-csel-trigger:focus,\n.fdp-csel-trigger[aria-expanded=\"true\"] {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102,126,234,0.15);\n}\n\nhtml.chakra-ui-dark .fdp-csel-trigger,\nbody.chakra-ui-dark .fdp-csel-trigger {\n  background: #1a2455;\n  border-color: rgba(255,255,255,0.12);\n  color: #e2e8f0;\n}\n\nhtml.chakra-ui-dark .fdp-csel-trigger:hover,\nbody.chakra-ui-dark .fdp-csel-trigger:hover {\n  border-color: #7c6fcd;\n}\n\nhtml.chakra-ui-dark .fdp-csel-trigger:focus,\nhtml.chakra-ui-dark .fdp-csel-trigger[aria-expanded=\"true\"],\nbody.chakra-ui-dark .fdp-csel-trigger:focus,\nbody.chakra-ui-dark .fdp-csel-trigger[aria-expanded=\"true\"] {\n  border-color: #a5b4fc;\n  box-shadow: 0 0 0 3px rgba(165,180,252,0.15);\n}\n\n.fdp-csel-value {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.fdp-csel-placeholder {\n  color: #a0aec0;\n}\n\nhtml.chakra-ui-dark .fdp-csel-placeholder,\nbody.chakra-ui-dark .fdp-csel-placeholder {\n  color: #4a5568;\n}\n\n.fdp-csel-arrow {\n  flex-shrink: 0;\n  color: #a0aec0;\n  transition: transform 0.18s;\n}\n\n.fdp-csel-arrow--open {\n  transform: rotate(180deg);\n}\n\n/* ─── Dropdown panel ───────────────────────────────────────────────── */\n.fdp-csel-dropdown {\n  background: #fff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.10), 0 2px 6px rgba(0,0,0,0.06);\n  overflow: hidden;\n  animation: fdp-csel-in 0.12s ease;\n}\n\n@keyframes fdp-csel-in {\n  from { opacity: 0; transform: translateY(-4px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\nhtml.chakra-ui-dark .fdp-csel-dropdown,\nbody.chakra-ui-dark .fdp-csel-dropdown {\n  background: #1e2d6b;\n  border-color: rgba(255,255,255,0.12);\n  box-shadow: 0 8px 24px rgba(0,0,0,0.35);\n}\n\n/* ─── Search box ───────────────────────────────────────────────────── */\n.fdp-csel-search-wrap {\n  padding: 8px 10px;\n  border-bottom: 1px solid #f0f0f5;\n  background: #fafbff;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\nhtml.chakra-ui-dark .fdp-csel-search-wrap,\nbody.chakra-ui-dark .fdp-csel-search-wrap {\n  background: #1a2455;\n  border-bottom-color: rgba(255,255,255,0.08);\n}\n\n.fdp-csel-search {\n  width: 100%;\n  padding: 6px 10px;\n  font-size: 12.5px;\n  font-weight: 500;\n  color: #2d3748;\n  background: #fff;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 6px;\n  outline: none;\n  font-family: inherit;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n}\n\n.fdp-csel-search:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102,126,234,0.12);\n}\n\nhtml.chakra-ui-dark .fdp-csel-search,\nbody.chakra-ui-dark .fdp-csel-search {\n  background: #111c44;\n  border-color: rgba(255,255,255,0.12);\n  color: #e2e8f0;\n}\n\n/* ─── Options list ─────────────────────────────────────────────────── */\n.fdp-csel-list {\n  max-height: 220px;\n  overflow-y: auto;\n  padding: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: #e2e8f0 transparent;\n}\n\n.fdp-csel-list::-webkit-scrollbar {\n  width: 5px;\n}\n\n.fdp-csel-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.fdp-csel-list::-webkit-scrollbar-thumb {\n  background: #e2e8f0;\n  border-radius: 4px;\n}\n\nhtml.chakra-ui-dark .fdp-csel-list::-webkit-scrollbar-thumb,\nbody.chakra-ui-dark .fdp-csel-list::-webkit-scrollbar-thumb {\n  background: rgba(255,255,255,0.12);\n}\n\n/* ─── Option item ──────────────────────────────────────────────────── */\n.fdp-csel-opt {\n  padding: 8px 12px;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: #2d3748;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.1s, color 0.1s;\n  user-select: none;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.fdp-csel-opt:hover {\n  background: #eef2ff;\n  color: #667eea;\n}\n\n.fdp-csel-opt--active {\n  background: #eef2ff;\n  color: #667eea;\n  font-weight: 600;\n}\n\nhtml.chakra-ui-dark .fdp-csel-opt,\nbody.chakra-ui-dark .fdp-csel-opt {\n  color: #e2e8f0;\n}\n\nhtml.chakra-ui-dark .fdp-csel-opt:hover,\nbody.chakra-ui-dark .fdp-csel-opt:hover {\n  background: rgba(102,126,234,0.15);\n  color: #a5b4fc;\n}\n\nhtml.chakra-ui-dark .fdp-csel-opt--active,\nbody.chakra-ui-dark .fdp-csel-opt--active {\n  background: rgba(102,126,234,0.2);\n  color: #a5b4fc;\n}\n\n/* ─── Empty state ──────────────────────────────────────────────────── */\n.fdp-csel-empty {\n  padding: 12px;\n  font-size: 12.5px;\n  color: #a0aec0;\n  text-align: center;\n}\n\n/* ═══════════════════════════════════════════════════════════════════\n   MULTI-SELECT (FdpMultiSelect)\n   ═══════════════════════════════════════════════════════════════════ */\n\n/* ─── Multi-select trigger (chips inside) ──────────────────────────── */\n.fdp-msel-trigger {\n  height: auto !important;\n  min-height: 40px;\n  align-items: flex-start !important;\n  padding: 6px 12px !important;\n  cursor: pointer;\n}\n\n.fdp-msel-trigger-inner {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n}\n\n.fdp-msel-chips-inline {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  padding: 2px 0;\n}\n\n/* ─── Selected chips row (legacy — kept for compat) ────────────────── */\n.fdp-msel-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  margin-top: 6px;\n}\n\n.fdp-msel-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px 3px 10px;\n  background: #eef2ff;\n  color: #667eea;\n  border: 1px solid #c7d2fe;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\nhtml.chakra-ui-dark .fdp-msel-chip,\nbody.chakra-ui-dark .fdp-msel-chip {\n  background: rgba(102,126,234,0.18);\n  color: #a5b4fc;\n  border-color: rgba(102,126,234,0.3);\n}\n\n.fdp-msel-chip-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border: none;\n  background: none;\n  color: #667eea;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  border-radius: 50%;\n  padding: 0;\n  transition: background 0.1s;\n}\n\n.fdp-msel-chip-remove:hover {\n  background: #c7d2fe;\n}\n\nhtml.chakra-ui-dark .fdp-msel-chip-remove,\nbody.chakra-ui-dark .fdp-msel-chip-remove {\n  color: #a5b4fc;\n}\n\nhtml.chakra-ui-dark .fdp-msel-chip-remove:hover,\nbody.chakra-ui-dark .fdp-msel-chip-remove:hover {\n  background: rgba(102,126,234,0.3);\n}\n\n/* ─── Option row ───────────────────────────────────────────────────── */\n.fdp-msel-opt {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.1s;\n  user-select: none;\n}\n\n.fdp-msel-opt:hover {\n  background: #f5f7ff;\n}\n\n.fdp-msel-opt--checked {\n  background: #eef2ff;\n}\n\nhtml.chakra-ui-dark .fdp-msel-opt:hover,\nbody.chakra-ui-dark .fdp-msel-opt:hover {\n  background: rgba(102,126,234,0.1);\n}\n\nhtml.chakra-ui-dark .fdp-msel-opt--checked,\nbody.chakra-ui-dark .fdp-msel-opt--checked {\n  background: rgba(102,126,234,0.18);\n}\n\n/* ─── Custom checkbox box ──────────────────────────────────────────── */\n.fdp-msel-checkbox {\n  width: 16px;\n  height: 16px;\n  border: 1.5px solid #cbd5e0;\n  border-radius: 4px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background 0.12s, border-color 0.12s;\n}\n\n.fdp-msel-checkbox--checked {\n  background: #667eea;\n  border-color: #667eea;\n}\n\nhtml.chakra-ui-dark .fdp-msel-checkbox,\nbody.chakra-ui-dark .fdp-msel-checkbox {\n  background: #1a2455;\n  border-color: rgba(255,255,255,0.2);\n}\n\nhtml.chakra-ui-dark .fdp-msel-checkbox--checked,\nbody.chakra-ui-dark .fdp-msel-checkbox--checked {\n  background: #667eea;\n  border-color: #667eea;\n}\n\n.fdp-msel-opt-label {\n  font-size: 13.5px;\n  font-weight: 500;\n  color: #2d3748;\n  flex: 1;\n}\n\nhtml.chakra-ui-dark .fdp-msel-opt-label,\nbody.chakra-ui-dark .fdp-msel-opt-label {\n  color: #e2e8f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
